// SubscriptionContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { endpoint } from "./endpoint";
import { useUser } from "./UserContext";
import Notiflix from "notiflix";

const SubscriptionContext = createContext();

export const SubscriptionProvider = ({ children }) => {
  const [subscription, setSubscription] = useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useUser();

  useEffect(() => {
    const fetchSubscription = async () => {
      if (!user || !user.token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${endpoint}/gymapp/getsubscription.php?token=${user.token}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();

        if (data.status === 'success') {
          setSubscription(data.subscription);
          setIsSubscribed(!!data.subscription);
        } else {
          setError(data.message || 'Failed to fetch subscription details.');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscription();
  }, [user]);

  const cancelSubscription = async () => {
    if (!user || !user.token) {
      Notiflix.Report.failure('User not authenticated', 'Please log in again.', 'OK');
      return;
    }

  
        try {
          const response = await fetch(`${endpoint}/gymapp/cancelsubscription.php`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              token: user.token,
            }),
          });

          const data = await response.json();

          if (data.status === 'success') {
            Notiflix.Notify.success("Subscription cancelled successfully.");
            setSubscription(null);  // Update state after successful cancellation
            setIsSubscribed(false);
            window.location.reload(); // Reload to reflect changes
          } else {
            Notiflix.Notify.failure(data.message || 'Failed to cancel subscription.');
          }
        } catch (error) {
          console.error("Error cancelling subscription:", error);
          Notiflix.Notify.failure('Error cancelling subscription. Please try again.');
        }
    
  };
  
      const upgradePlan = async (newPlan, price, paymentToken) => {
        //setIsProcessing(true);

        try {
            const response = await fetch(`${endpoint}/gymapp/upgradeplan.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: user.token,
                    newPlan,
                    paymentToken,
                    amount: price,
                }),
            });
            const data = await response.json();
            if (data.status === 'success') {
                Notiflix.Notify.success("Plan upgraded successfully!");
                window.location.reload();
            } else {
                Notiflix.Notify.failure(data.message || 'Failed to upgrade plan.');
            }
        } catch (error) {
            console.error("Error upgrading plan:", error);
            Notiflix.Notify.failure('Error upgrading plan.');
        }

        //setIsProcessing(false);
    };

  return (
    <SubscriptionContext.Provider value={{ upgradePlan,cancelSubscription, subscription, isSubscribed, loading, error }}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);
